import { render } from "./AppMenu.vue?vue&type=template&id=1f7e627d&scoped=true&ts=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"

import "./AppMenu.vue?vue&type=style&index=0&id=1f7e627d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7e627d"]])

export default __exports__